import React from "react";
import { GraduationCap, Check, X, Lightbulb } from "lucide-react";

const scoreColor = (s) => (s >= 75 ? "#10B981" : s >= 50 ? "#F59E0B" : "#EF4444");

export default function ScenarioDebrief({ open, data, onClose }) {
  if (!open || !data) return null;
  const c = scoreColor(data.score);
  return (
    <div data-testid="scenario-debrief" className="fixed inset-0 z-[999] flex items-start justify-center bg-black/70 backdrop-blur-sm p-4 overflow-y-auto">
      <div className="w-full max-w-lg bg-[#141518] border border-[#F59E0B]/50 my-6">
        <div className="flex items-center gap-2 px-4 py-3 border-b border-[#2C2D35] bg-[#0d0e11]">
          <GraduationCap size={16} className="text-[#F59E0B]" />
          <div className="font-head font-semibold text-sm text-white">After-Action Debrief · {data.title}</div>
          <button data-testid="debrief-close" onClick={onClose} className="ml-auto text-[#9CA3AF] hover:text-white"><X size={18} /></button>
        </div>

        <div className="p-4 space-y-4">
          {/* score */}
          <div className="flex items-center gap-4 border border-[#2C2D35] bg-[#0d0e11] p-3">
            <div className="text-center">
              <div data-testid="debrief-score" className="font-head font-bold text-4xl leading-none" style={{ color: c }}>{data.score}%</div>
              <div className="font-mono text-[9px] text-[#9CA3AF] uppercase mt-1">Score</div>
            </div>
            <div className="text-xs text-[#9CA3AF] leading-snug">{data.objective}</div>
          </div>

          {/* breakdown */}
          <div className="space-y-1.5">
            {(data.breakdown || []).map((b, i) => (
              <div key={i} data-testid={`debrief-item-${i}`} className="border border-[#2C2D35] bg-[#0d0e11] px-3 py-2">
                <div className="flex items-center gap-2">
                  {b.pass
                    ? <Check size={14} className="text-[#10B981] shrink-0" />
                    : <X size={14} className="text-[#EF4444] shrink-0" />}
                  <span className="font-head text-sm text-white">{b.label}</span>
                  <span className="ml-auto font-mono text-[10px]" style={{ color: b.pass ? "#10B981" : "#EF4444" }}>
                    {b.pass ? "CORRECT" : "REVIEW"}
                  </span>
                </div>
                <div className="font-mono text-[10px] text-[#9CA3AF] mt-1 pl-6">
                  Your answer: <span className="text-[#F3F4F6]">{b.got}</span>
                </div>
                {!b.pass && (
                  <div className="font-mono text-[10px] text-[#F59E0B] mt-0.5 pl-6">Ideal: {b.expected}</div>
                )}
              </div>
            ))}
          </div>

          {/* coaching */}
          {data.coaching && (
            <div className="border-l-2 border-[#3B82F6] bg-[#3B82F6]/[0.07] px-3 py-2 flex gap-2">
              <Lightbulb size={14} className="text-[#3B82F6] shrink-0 mt-0.5" />
              <div className="text-xs text-[#F3F4F6] leading-snug"><b className="text-[#3B82F6]">Instructor tip — </b>{data.coaching}</div>
            </div>
          )}

          <button data-testid="debrief-done" onClick={onClose}
            className="w-full py-2.5 text-sm font-head font-semibold bg-[#F59E0B] text-black hover:bg-[#d97706] transition-colors">
            Done — Return to Command Center
          </button>
        </div>
      </div>
    </div>
  );
}
